import nodeClient from "./node-client";

export const addModeConfig = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/modeConfig/add`,
    payload
  );
  return response?.data;
};

export const fetchModeConfigDetails = async (query) => {
  const response = await nodeClient.get(
    `/service/protected/v0/modeConfig/findOne?${query}`
  );
  return response?.data?.result;
};

export const fetchModeConfigPotency = async (query) => {
  const response = await nodeClient.get(
    `/service/protected/v0/modeConfig/potency?${query}`
  );
  return response?.data;
};

export const fetchModeConfigDosageMarks = async (query) => {
  const response = await nodeClient.get(
    `/service/protected/v0/modeConfig/dosageMark?${query}`
  );
  return response?.data;
};

export const fetchModeConfigPackaging = async (query) => {
  const response = await nodeClient.get(
    `/service/protected/v0/modeConfig/packaging?${query}`
  );
  return response?.data;
};
